var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3AD1D6EA-FE80-43BB-98BA-AF3E2E3A6A75") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enclosures-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AMFG-Enclosures-OnePager-v1",
    transform: "translate(-1213.000000, -12840.000000)",
    fill: "#E9E9E9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(0.000000, 12764.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1037.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sm-linkedin",
    transform: "translate(176.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6,0 C9.72,0 0,9.72 0,21.6 C0,33.48 9.72,43.2 21.6,43.2 C33.48,43.2 43.2,33.48 43.2,21.6 C43.2,9.72 33.48,0 21.6,0 Z M16.38,32.04 L11.88,32.04 L11.88,17.1 L16.56,17.1 L16.56,32.04 L16.38,32.04 Z M14.04,15.12 C12.6,15.12 11.52,14.04 11.52,12.42 C11.52,10.98 12.78,9.72 14.22,9.72 C15.66,9.72 16.92,10.98 16.92,12.42 C16.74,14.04 15.66,15.12 14.04,15.12 Z M33.66,32.04 L33.66,32.04 L28.98,32.04 L28.98,24.84 C28.98,23.04 28.98,20.88 26.64,20.88 C24.3,20.88 23.94,22.68 23.94,24.66 L23.94,32.04 L19.26,32.04 L19.26,17.1 L23.76,17.1 L23.76,19.08 L23.76,19.08 C24.3,18 25.92,16.74 28.08,16.74 C32.76,16.74 33.66,19.8 33.66,23.76 L33.66,32.04 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.102a464d495962a2ee3b77fdfd7b9824.svg";
export { ForwardRef as ReactComponent };